import { render } from "./ListItemContacto.vue?vue&type=template&id=56619efe&scoped=true"
import script from "./ListItemContacto.vue?vue&type=script&lang=js"
export * from "./ListItemContacto.vue?vue&type=script&lang=js"

import "./ListItemContacto.vue?vue&type=style&index=0&id=56619efe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56619efe"]])

export default __exports__